
<div class="row" *ngIf="isOrderRejected">
  <div class="col">
    <div class="alert alert-danger"><span>This order has been rejected because: {{ rejectedReason }}</span></div>
  </div>
</div>